import { MenuList, MenuListProps } from "@mui/material";

export type FilterMenuListProps = MenuListProps & {};

export function FilterMenuList({
  children,
  sx = [],
  ...rest
}: FilterMenuListProps) {
  return (
    <MenuList
      disablePadding
      sx={[
        {
          maxHeight: "calc(100vh - 152px)",
          overflow: "auto",
          pt: 0,
          mb: 2,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...rest}
    >
      {children}
    </MenuList>
  );
}
